'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 *
 */
var NumberInputControl = function NumberInputControl(_ref) {
	var name = _ref.name;
	var title = _ref.title;
	var text = _ref.text;
	var onClick = _ref.onClick;

	var className = (0, _classnames2.default)(['rea11y-NumberInputControl', 'rea11y-NumberInputControl-' + name]);

	return _react2.default.createElement(
		'button',
		{
			className: className,
			title: title,
			onClick: onClick
		},
		text
	);
};

NumberInputControl.propTypes = {
	name: _react.PropTypes.string,
	title: _react.PropTypes.string,
	text: _react.PropTypes.string,
	onClick: _react.PropTypes.func
};

exports.default = (0, _recompose.pure)(NumberInputControl);